import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Item } from "@template/types";

export type ItemsStatus = "idle" | "loading" | "succeeded" | "failed";

export interface ItemsState {
  items: Item[];
  status: ItemsStatus;
  error: string | null;
}

const initialState: ItemsState = {
  items: [],
  status: "idle",
  error: null,
};

const itemsSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    itemsRequestStarted(state) {
      state.status = "loading";
      state.error = null;
    },
    itemsLoaded(state, action: PayloadAction<Item[]>) {
      state.items = action.payload;
      state.status = "succeeded";
    },
    itemsRequestFailed(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
    itemAdded(state, action: PayloadAction<Item>) {
      state.items.unshift(action.payload);
    },
    itemUpdated(state, action: PayloadAction<Item>) {
      const index = state.items.findIndex((item) => item.id === action.payload.id);
      if (index !== -1) state.items[index] = action.payload;
    },
    itemRemoved(state, action: PayloadAction<string>) {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
});

export const {
  itemsRequestStarted,
  itemsLoaded,
  itemsRequestFailed,
  itemAdded,
  itemUpdated,
  itemRemoved,
} = itemsSlice.actions;

export default itemsSlice.reducer;
